import React from "react";
import { RoughNotation } from "react-rough-notation";
import { Fade } from "react-awesome-reveal";

export default function About() {
  return (
    <div>
      <div className="container-fluid main">
        <div className="row">
          <div className="col-sm-4">
            <h1 className="head">
              I’m{" "}
              <RoughNotation
                type="underline"
                show="true"
                color="#e85a71"
                strokeWidth={2}
                multiline="true"
                padding={0}
              >
                Anshul Gora
              </RoughNotation>
              . Nice to meet you.
            </h1>
            <br />
            <br />
            <h5>Email :</h5>
            <a className="iconf" href="mailto:ianshulgora+web@gmail.com">
              ianshulgora@gmail.com
            </a>
            <br />
            <br />
            <h5>Say Hello :</h5>
            <a href="https://instagram.com/ianshulgora" target="blank">
              <i className="fab iconf fa-instagram fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://www.linkedin.com/in/anshul-gora" target="blank">
              <i className="fab iconf fa-linkedin-in fa-2x fa-beat"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://twitter.com/ianshulgora" target="blank">
              <i className="fab iconf fa-x-twitter fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <a href="https://github.com/anshulgora" target="blank">
              <i className="fab iconf fa-github fa-2x"></i>
            </a>
            &nbsp; &nbsp;
            <br />
            <br />
            <br />
            <br />
          </div>
          <div className="col-sm-8  me">
            <h5 className="text-muted">
              I’m a Frontend Developer who enjoys solving complex problems,
              creating impactful and user-centered experiences across multiple
              platforms that are informed by research and data.
              <br /> <br />
              I'm probably not the typical designer positioned behind an
              Illustrator artboard adjusting pixels, but I design. Immersed in
              stylesheets tweaking font sizes and contemplating layouts is where
              you'll find me. I'm committed to creating fluent user experiences
              while staying fashionable.
              <br /> <br />
              When it comes to business, first impressions matter, and good
              website design is the key to capitalizing on them. An excellent
              site is not judged solely on its looks, but on its functionality
              and usability as well. My experience as a programmer allows me to
              come up with intelligent solutions to technical challenges, while
              at the same time designing sleek and visually appealing websites.
              Aside from having extensive knowledge of recognized technical
              standards, I am conversant with modern building practices.
            </h5>
            <br />

            {/* <button className="btn">View Resume(pdf)</button> */}
            {/* <a
              className="btn"
              href=""
              download="Anshul Gora Resume.pdf"
              target="blank"
            >
              View Resume (PDF)
            </a> */}
            <Fade direction="up" duration={3000}>
              <h5 className="hoverclass">view my resume</h5>
            </Fade>
            <button
              className="btn"
              onClick={() => {
                const enteredCode = prompt("Please enter the code:");
                const correctCode = "14516052";
                if (enteredCode === correctCode) {
                  const link = document.createElement("a");
                  link.href =
                    "https://drive.google.com/file/d/102CijPxDlHqZiNlGZBG0qvgSy4XEPmYi/view?usp=drive_link";
                  link.download = "Anshul Gora.pdf";
                  link.click();
                } else {
                  alert("Incorrect code. Access denied.");
                }
              }}
            >
              Resume <i className="ri-file-text-line"></i>
            </button>
            <br />
            <br />

            <Fade direction="down" duration={2000}>
              <div className="accordion-item">
                <button
                  className="collapsed btn-available"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  <i class="ri-codepen-fill iconf"></i>{" "}
                  <span className="fw-bold">Tech-Stack and Tools </span>
                </button>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <div className="tech-icons py-2">
                      <i className="ci ci-reactjs ci-3x icontech"></i>
                      <i className="ci ci-firebase ci-3x icontech"></i>
                      <i className="ci ci-html5 ci-3x icontech"></i>
                      <i className="ci ci-css ci-3x icontech"></i>
                      <i className="ci ci-javascript ci-3x icontech"></i>
                      <i className="ci ci-bootstrap ci-3x icontech"></i>
                      <i className="ci ci-tailwind ci-3x icontech"></i>
                      &nbsp; &nbsp; &nbsp;
                      <i className="ci ci-vscode ci-3x icontech"></i>
                      <i className="ci ci-github ci-3x icontech"></i>
                      <i className="ci ci-python ci-3x icontech"></i>
                      <i className="ci ci-cpp ci-3x icontech"></i>
                      <i className="ci ci-c ci-3x icontech"></i>
                      &nbsp; &nbsp; &nbsp;
                      <i className="ci ci-figma ci-3x icontech"></i>
                      <i className="ci ci-npm ci-3x icontech"></i>
                      <i className="ci ci-netlify ci-3x icontech"></i>
                      <i className="ci ci-vercel ci-3x icontech"></i>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
            {/* <h5 className="my-2 fw-bolder">Tech-Stack and Tools</h5>
            <div className="tech-icons">
              <i className="ci ci-reactjs ci-3x icontech"></i>
              <i className="ci ci-firebase ci-3x icontech"></i>
              <i className="ci ci-javascript ci-3x icontech"></i>
              <i className="ci ci-css ci-3x icontech"></i>
              <i className="ci ci-bootstrap ci-3x icontech"></i>
              <i className="ci ci-tailwind ci-3x icontech"></i>
              <i className="ci ci-html5 ci-3x icontech"></i>

              <i className="ci ci-vscode ci-3x icontech"></i>
              <i className="ci ci-github ci-3x icontech"></i>
              <i className="ci ci-python ci-3x icontech"></i>
              <i className="ci ci-cpp ci-3x icontech"></i>
              <i className="ci ci-c ci-3x icontech"></i>

              <i className="ci ci-figma ci-3x icontech"></i>

              <i className="ci ci-npm ci-3x icontech"></i>

              <i className="ci ci-netlify ci-3x icontech"></i>
              <i className="ci ci-vercel ci-3x icontech"></i>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}
